import { NavLink } from 'react-router-dom';
import { Icon, type IconName } from './Icon';

interface NavItem {
  to: string;
  label: string;
  icon: IconName;
  end?: boolean;
}

/**
 * What a phone is for: reading the numbers.
 *
 * The wide working surfaces — the ОПУ sheet, Сравнение, Объекты, Импорты,
 * Требует внимания — are desktop tools. They stay routed and reachable on a
 * large screen; a phone simply does not offer them, rather than offering them
 * in a form nobody can use. Creating or editing a restaurant is deliberately
 * not reachable here either.
 */
const PRIMARY: NavItem[] = [
  { to: '/', label: 'Обзор', icon: 'grid', end: true },
  { to: '/company', label: 'Компания', icon: 'building' },
  { to: '/expenses', label: 'Расходы', icon: 'coins' },
  { to: '/production', label: 'Производство', icon: 'factory' },
];

export function MobileNav() {
  // Exactly the four sections, for everyone: the bar is what a phone is for
  // (reading the numbers). Операции, Настройки and Журнал аудита are reached
  // from the avatar menu on a phone (Topbar), each still only when the
  // session holds the right to it.
  const items = PRIMARY;

  return (
    <nav
      className="mobile-nav rt-tabbar"
      aria-label="Основная навигация"
      // Placement and the safe-area inset live in styles/glass.css (a fixed
      // bar in the classic skin, a floating capsule in the glass one); the
      // bar is shown on a phone by global.css.
      style={{ display: 'none' }}
    >
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          // Colour and the active capsule come from styles/glass.css.
          className={({ isActive }) =>
            isActive ? 'rt-tabbar__item rt-tabbar__item--active' : 'rt-tabbar__item'
          }
          style={{
            // Equal shares of the bar, and never narrower than a fingertip.
            flex: '1 1 0',
            minWidth: 0,
            minHeight: 44,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
            padding: '4px 2px',
          }}
        >
          <Icon name={item.icon} size={24} />
          <span
            style={{
              fontSize: 10.5,
              lineHeight: 1.15,
              // A long caption shrinks rather than pushing the bar wider.
              maxWidth: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {item.label}
          </span>
        </NavLink>
      ))}
    </nav>
  );
}
